export enum MetadataTypeBE {
	Connector = 'CONNECTOR',
	Datasource = 'DATA_SOURCE',
	Entity = 'ENTITETYPE',
	Caracteristique = 'CARACTERISTIQUE',
	Datablock = 'DATABLOCK',
	Dashboard = 'DASHBOARD',
	Depot = 'DEPOT',
	Map = 'MAP',
	Timeline = 'TIMELINE',
	Chart = 'CHART',
	Media = 'MEDIA',
	Grid = 'GRID',
	ExportTemplate = 'EXPORT_TEMPLATE',
	Exposition = 'EXPOSITION',
	DataLink = 'DATALINK',
	Users = 'USERS',
	Tag = 'tag',
	Pictogramme = 'pictogramme',
	Column = 'COLUMN',
	Ranking = 'RANKING',
	Default = '',
}

export interface IDcMetadataResponse {
	id?: number;
	label: string;
	description: string;
	actif: boolean;
	imported?: boolean;
	code?: string;
	created_by?: string;
	updated_by?: string;
	creation_date?: number;
	update_date?: number;
	icon_id?: number;
	project?: IDcMetadataProjectResponse;
	tags?: Array<IMetadataTag>;
	hdh_type?: MetadataTypeBE;
}

export interface IDcMetadataProjectResponse {
	id: number;
	metadata: IDcMetadataResponse;
}

export interface IMetadataTag {
	id?: number;
	code: string;
	color: string;
	position: number;
}

export interface IMetadataElement {
	v1?: string;
	v2?: number;
}
